import { useTranslation } from "@impero-com/common/utils/i18n";
import { TimeToDueDateFilter as FilterValue } from "@impero-com/ui/domain";
import { Select, Space } from "antd";

import { TimeToDueDateFilterInputs } from "./TimeToDueDateFilterInputs";

export function TimeToDueDateFilter({
    value,
    onChange,
}: {
    value: FilterValue | null;
    onChange: (value: FilterValue) => void;
}) {
    const { t } = useTranslation();
    return (
        <Space wrap size="middle">
            <Select
                style={{ minWidth: 120 }}
                dropdownMatchSelectWidth={false}
                aria-label={t("ControlActivitiesList_TimeToDueDate_Condition")}
                placeholder={t("ControlActivitiesList_TimeToDueDate_Condition")}
                value={value?.direction}
                onChange={(direction: FilterValue["direction"]) =>
                    onChange({
                        direction,
                        unit: value?.unit ?? "hours",
                        comparison: value?.comparison ?? {
                            type: "atLeast",
                            value: 0,
                        },
                    })
                }
                options={[
                    {
                        value: "overdue",
                        label: t(
                            "ControlActivitiesList_TimeToDueDate_IsOverdueBy"
                        ),
                    },
                    {
                        value: "upcoming",
                        label: t("ControlActivitiesList_TimeToDueDate_IsIn"),
                    },
                ]}
            />
            {value && (
                <TimeToDueDateFilterInputs value={value} onChange={onChange} />
            )}
        </Space>
    );
}
